export const parseUtcDateTime = (dateTime?: string | null): number | null => {
  if (!dateTime) {
    return null
  }

  const hasTimezone = dateTime.endsWith("Z") || /[+-]\d{2}:\d{2}$/.test(dateTime)
  const parsed = Date.parse(hasTimezone ? dateTime : `${dateTime}+00:00`)

  return Number.isNaN(parsed) ? null : parsed
}
